import React from "react";

const ButtonContainer = ({ children }) => {
  return <div id="bottom-wizard">{children}</div>;
};

export default ButtonContainer;
